import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { AlternatingTextLinkControl } from 'projects/money-movement-ui/src/app/create-request/models/form/FormControlAlternatingTextLink';
import { createControl } from 'projects/money-movement-ui/src/app/create-request/utilities/formUtilities';
import { Observable, Subject, map } from 'rxjs';

@Component({
  standalone: false,
  selector: 'mm-alternating-text-link-control',
  templateUrl: './alternating-text-link-control.component.html',
  styleUrls: ['./alternating-text-link-control.component.scss']
})
export class AlternatingTextLinkControlComponent implements OnInit {
  @Input() parentForm!: UntypedFormGroup;
  @Input() alternatingTextLinkControlModel!: AlternatingTextLinkControl;
  @Input() isLinkEnabled: boolean;
  @Input() selectedValue$: Observable<string>;
  isText1$: Observable<boolean>;
  isText1: boolean = true;
  private destroy$ = new Subject<void>();

  constructor( ) {}

  ngOnInit(): void {
    createControl(this.parentForm, this.alternatingTextLinkControlModel.controlName, this.alternatingTextLinkControlModel.text1.value, [Validators.required], undefined);
    this.isText1$ = this.selectedValue$.pipe(map((selection) => selection === this.alternatingTextLinkControlModel.text1.value));
    const subcription = this.isText1$.subscribe((value: boolean)=>{
      this.isText1 = value;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  changeAlternateTextState(){
    if(this.isText1){
      this.parentForm.controls[this.alternatingTextLinkControlModel.controlName].setValue(this.alternatingTextLinkControlModel.text2.value);
    } else {
      this.parentForm.controls[this.alternatingTextLinkControlModel.controlName].setValue(this.alternatingTextLinkControlModel.text1.value);
    }
  }
}
